import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: 'app-weave-email',
    templateUrl: './weave-email.component.html',
    styleUrls: ['./weave-email.component.scss'],
    standalone: false
})
export class WeaveEmailComponent implements OnInit, OnDestroy {

  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() description: string = "";
  @Input() placeholder: string = "";
  @Input() maxlength: number = 524288;
  @Input() required: boolean = false;
  @Input() showError: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUp: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUpDebounced: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;
  id: string = "";
  message: string = "";

  private keyUpDebouncedSubject  = new Subject<string>();
  private keyUpDebouncedSubscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.id = "weave-input" + Math.floor(Math.random() * 1000);

    this.keyUpDebouncedSubscription = this.keyUpDebouncedSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((results: string) => (this.keyUpDebounced.emit(results)));

    this.message = this.label;
    if( this.message.length > 30 || this.message.length == 0 ) {
      this.message = "This field";
    }
  }

  ngOnDestroy() {
    this.keyUpDebouncedSubscription.unsubscribe();
  }

  onFocusOut() {
    this.showError = false;
    this.focusOut.emit(this.data);
  }
  onKeyUp() {
    this.keyUp.emit(this.data);

    this.keyUpDebouncedSubject.next(this.data)
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }

}
